export class MissingDbMigrationsError extends Error {
  constructor(oldDbVersion: number, requestedDbVersion: number) {
    super(`No migrations found to migrate from IDb version ${oldDbVersion} to IDb version ${requestedDbVersion}.`);
    this.name = "MissingDbMigrationsError";
  }
}